import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { useKinderConnectCaptureGate } from '@famly/stat_kinder-connect-capture_business-logic';
import translate from 'signin-app/helpers/translate';
import { getSiteId } from 'signin-app/login/selectors';
import { pinHolder } from 'signin-app/pin/selectors';
import { ConfirmButton, ActionButton, BottomBarContainer, ActionOnClickButton, } from 'signin-app/components/action-buttons';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { checkOutChild } from './actions';
import * as Selectors from './selectors';
import { useCheckOutChild } from './check-out-child-context';
export const CheckOutSubmit = (props) => {
    const { child, displayName } = useCheckOutChild();
    const { showSwitchRoomView } = props;
    const isCheckingOut = useTypedSelector(Selectors.isCheckingOut);
    const pin = useTypedSelector(pinHolder);
    const dispatch = useDispatch();
    const canSwitchRoom = useTypedSelector(Selectors.canSwitchRoom);
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const siteId = useTypedSelector(getSiteId);
    const { isLoading: isKCCaptureLoading, runOrCapture: runOrCaptureKC } = useKinderConnectCaptureGate([child.id], siteId);
    const handleChildCheckOut = React.useCallback(() => {
        runOrCaptureKC(kcData => dispatch(checkOutChild.action(child.id, pin, kcData)));
    }, [dispatch, child.id, pin, runOrCaptureKC]);
    return (_jsx(BottomBarContainer, { children: _jsxs(Stack, { direction: "column", width: "100%", gap: 3, children: [_jsxs(Stack, { gap: 4, children: [canSwitchRoom && (_jsx(ActionOnClickButton, { text: translate('movePersonToRoom', { personName: displayName }), onClick: showSwitchRoomView, compact: !isTabletPortraitAndLarger })), _jsx(ActionButton, { text: translate('changePickUp'), link: `/child/${child.id}/checkin?update`, compact: !isTabletPortraitAndLarger && canSwitchRoom })] }), _jsx(Box, { children: _jsx(ConfirmButton, { type: 'signOut', text: translate('signOut', { personName: displayName }), isLoading: isCheckingOut || isKCCaptureLoading, onClick: handleChildCheckOut, dataE2EId: "child-check-out-confirm-button" }) })] }) }));
};
